(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["king-popup"]) return;
  try {
    
    (function () {
      var root = document.querySelector('[data-king-popup]');
      if (!root) return;

      var enabled = root.getAttribute('data-enabled') === 'true';
      var forceOpen = root.getAttribute('data-force-open') === 'true';
      var frequency = root.getAttribute('data-frequency') || 'day';
      var delay = parseInt(root.getAttribute('data-delay'), 10) || 0;
      var storageKey = 'kingPopupDismissedAt';

      function shouldShow() {
        if (forceOpen) return true;
        if (!enabled) return false;
        if (frequency === 'always') return true;
        if (frequency === 'session') return !sessionStorage.getItem(storageKey);
        if (frequency === 'once') return !localStorage.getItem(storageKey);
        if (frequency === 'day') {
          var last = localStorage.getItem(storageKey);
          if (!last) return true;
          return (Date.now() - parseInt(last, 10)) > 86400000;
        }
        return true;
      }

      function remember() {
        if (frequency === 'session') {
          sessionStorage.setItem(storageKey, '1');
        } else {
          localStorage.setItem(storageKey, Date.now().toString());
        }
      }

      function open() {
        root.classList.add('is-open');
      }
      function close() {
        root.classList.remove('is-open');
        remember();
      }

      root.querySelectorAll('[data-king-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });
      root.addEventListener('click', function (e) {
        if (e.target === root) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });

      if (shouldShow()) {
        if (forceOpen) {
          open();
        } else {
          window.setTimeout(open, delay * 1000);
        }
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["king-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-king-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-king-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);

      var variantIdInput = root.querySelector('[data-king-variant-id]');
      var priceEl = root.querySelector('[data-king-price]');
      var addBtn = root.querySelector('[data-king-add]');
      var addText = root.querySelector('[data-king-add-text]');
      var mainImg = root.querySelector('[data-king-main-image]');
      var optionGroups = root.querySelectorAll('[data-king-option]');
      var thumbs = root.querySelectorAll('[data-king-thumb]');
      var addLabel = (addText && addText.textContent.trim()) || 'Aggiungi al carrello';
      var soldOutLabel = 'Esaurito';

      function selectedOptionValues() {
        var values = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.is-active');
          values.push(active ? active.getAttribute('data-value') : null);
        });
        return values;
      }

      function findVariant() {
        if (optionGroups.length === 0) return variants[0];
        var selected = selectedOptionValues();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function updateUI() {
        var variant = findVariant();
        if (!variant) {
          addBtn.disabled = true;
          addText.textContent = 'Non disponibile';
          return;
        }
        variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        if (variant.featured_image && mainImg) {
          mainImg.src = variant.featured_image;
        }
        if (variant.available) {
          addBtn.disabled = false;
          addText.textContent = addLabel;
        } else {
          addBtn.disabled = true;
          addText.textContent = soldOutLabel;
        }
      }

      optionGroups.forEach(function (group) {
        group.querySelectorAll('[data-king-option-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('[data-king-option-value]').forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            updateUI();
          });
        });
      });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) {
            mainImg.src = thumb.getAttribute('data-full');
            mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
